import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

// 解决 Vue Router 3.x 在导航守卫中重定向时抛出 "Redirected when going from..." 的 Uncaught Promise Error
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => {
    if (VueRouter.isNavigationFailure(err)) {
      return err
    }
    return Promise.reject(err)
  })
}

const originalReplace = VueRouter.prototype.replace
VueRouter.prototype.replace = function replace(location, onResolve, onReject) {
  if (onResolve || onReject) return originalReplace.call(this, location, onResolve, onReject)
  return originalReplace.call(this, location).catch(err => {
    if (VueRouter.isNavigationFailure(err)) {
      return err
    }
    return Promise.reject(err)
  })
}

const routes = [
  {
    path: '/',
    name: 'Login',
    component: () => import('@/views/Login.vue'),
    meta: {
      title: '授权登录',
      keepAlive: false
    }
  },
  {
    path: '/apply-dept',
    name: 'ApplyDept',
    component: () => import('@/views/ApplyDept.vue'),
    meta: {
      title: '部门申请',
      keepAlive: false,
      requiresAuth: true
    }
  },
  {
    path: '/main',
    component: () => import('@/views/layout/index.vue'),
    redirect: '/home',
    children: [
      {
        path: '/home',
        name: 'Home',
        component: () => import('@/views/Home.vue'),
        meta: {
          title: '首页',
          keepAlive: false,
          requiresAuth: true
        }
      },
      {
        path: '/features',
        name: 'Features',
        component: () => import('@/views/features/index.vue'),
        meta: {
          title: '消息通知',
          keepAlive: false,
          requiresAuth: true
        }
      },
      {
        path: '/profile',
        name: 'Profile',
        component: () => import('@/views/Profile.vue'),
        meta: {
          title: '个人',
          keepAlive: false,
          requiresAuth: true
        }
      },
      {
        path: '/rent-units',
        name: 'RentUnits',
        component: () => import('@/views/rentUnits/index.vue'),
        meta: {
          title: '租赁单元',
          keepAlive: false,
          requiresAuth: true
        }
      },
      {
        path: '/daily-bills',
        name: 'DailyBills',
        component: () => import('@/views/dailyBills/index.vue'),
        meta: {
          title: '日结账单',
          keepAlive: false,
          requiresAuth: true
        }
      },
      {
        path: '/monthly-bills',
        name: 'MonthlyBills',
        component: () => import('@/views/monthlyBills/index.vue'),
        meta: {
          title: '月结账单',
          keepAlive: false,
          requiresAuth: true
        }
      }
    ]
  },
  {
    path: '/pay-apply',
    name: 'PayApply',
    component: () => import('@/views/payApply/index.vue'),
    meta: {
      title: '支付申请',
      keepAlive: false,
      requiresAuth: true
    }
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})

router.beforeEach((to, from, next) => {
  document.title = to.meta.title || '授权登录'

  if (to.meta.requiresAuth) {
    const token = localStorage.getItem('token')
    if (!token) {
      next({ path: '/', query: { redirect: to.fullPath } })
      return
    }
    
    // Check deptId
    const userInfoStr = localStorage.getItem('userInfo')
    let userInfo = null
    if (userInfoStr) {
      try {
        userInfo = JSON.parse(userInfoStr)
      } catch (e) {
        console.error('Failed to parse userInfo', e)
      }
    }
    
    if (to.path !== '/apply-dept') {
      // 修复: 只有当 deptId 为 null 或 undefined 时才跳转，如果 deptId 为 0 则认为是有效部门
      if (!userInfo || (userInfo.deptId === null || userInfo.deptId === undefined)) {
        next({ path: '/apply-dept' })
        return
      }
    }
  }

  next()
})

export default router
